import React from "react";
import { SectionInterface } from "../interfaces/Section";
import Business from "../assets/business.jpg";
// import { motion, useScroll, useTransform } from "framer-motion";

const SectionBelow = ({
  sectionInterface,
}: {
  sectionInterface: SectionInterface;
}) => {
  // const ref = useRef<HTMLDivElement | null>(null);

  // // obserwujemy widoczność sekcji
  // const { scrollYProgress } = useScroll({
  //   target: ref,
  //   offset: ["0 1", "1 0"],
  //   /*
  //     "0 1" = kiedy górna krawędź elementu dotknie dolnej krawędzi viewport
  //     "1 0" = kiedy dolna krawędź elementu dotknie górnej krawędzi viewport
  //   */
  // });

  // mapujemy progress (0 → 1) na przesunięcie w osi X§
  // np. na początku jest +200px, w połowie +100px, na końcu 0
  // element osiąga docelową pozycję już przy scrollYProgress = 0.5
  // const x = useTransform(scrollYProgress, [0, 0.5], [-150, 0]);
  // const opacity = useTransform(scrollYProgress, [0, 0.5], [0, 1]);
  // const x = useTransform(scrollYProgress, [0, 0.3], [-150, 0]);
  // const opacity = useTransform(scrollYProgress, [0, 0.3], [0, 1]);

  return (
    <div className="w-full bg-white py-16 px-4">
      {/* <motion.div */}
        {/* ref={ref} */}
        {/* style={{ x, opacity }} */}
        <div className="max-w-[1240px] mx-auto grid md:grid-cols-2">
      {/* > */}
        <div className="flex gap-2">
          <div className="flex items-center justify-center">
            <div className="-rotate-90 md:text-4xl sm:text3xl 2xl font-bold">
              {sectionInterface.title}
            </div>
            <div className="p-2">
              <p className="text-[#00df9a] font-bold">
                BUSINESS-ORIENTED DEVELOPMENT
              </p>
              <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-2">
                Direct business impact
              </h1>
              <p>
                I don’t just write code — I understand business objectives and
                translate them into functional, user-focused solutions. By
                aligning development with your goals, I help deliver products
                that not only work technically but also create measurable
                business value, improve customer experience, and drive growth.
              </p>
            </div>
          </div>
        </div>
        <div>
          <img src={Business} alt="/" className="w-[500px] mx-auto my-4" />
        </div>
      </div>
    </div>
  );
};

export default SectionBelow;
